import { Component, OnInit, ViewContainerRef, ElementRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import JSONFormatter from 'json-formatter-js';
import { CoreEngineObject, CoreEngineService } from '../../_services/core-engine.service';
import { DialogService } from '../../_services/dialog.service';

@Component({
  selector: 'app-core-engine-form',
  templateUrl: './core-engine.component.html',
  styleUrls: ['./core-engine.component.css'],
})

export class CoreEngineFormComponent implements OnInit {

  public id = -1;
  public formatter: JSONFormatter;
  public loadingMessage = 'Loading Audio QR Codes...';
  public loading = false;
  public formLoaded: boolean;

  public json: object = {};
  
  public jsonPairs = [];
  public nestTracker = [];

  public objectName = '';

  public originalObjectName = '';

  public outputJson: any;

  constructor(
    private viewRef: ViewContainerRef,
    public dialogService: DialogService,
    private coreEngineService: CoreEngineService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.spinner.show();
    this.route.params
      .pipe(mergeMap(params => {
        this.id = params['id'];
        if (this.id > 0) {
          return this.coreEngineService.getCoreEngineObjectById(this.id);
        } else {
          return of({
            id: this.id,
            name: '',
            payload: '',
            triggerParameters: '',
            fileDownloadUrl: ''
          } as CoreEngineObject);
        }
      }))
      .subscribe(
        data => {
          this.objectName = data.name;
          this.originalObjectName = data.name;
          this.json = data.payload;
          this.loading = false;
          this.spinner.hide();
      });
  }

  public save(copy: boolean) {

    if (this.outputJson?.length === 0) {
      return;
    }

    this.loading = true;
    this.spinner.show();
    const on = this.objectName.split(' ').join('_');

    const objectData = {
      id: copy ? -1 : this.id,
      name: this.originalObjectName === on && copy ? on + '_copy' : on,
      payload: this.outputJson,
      triggerParameters: '',
      fileDownloadUrl: '' } as CoreEngineObject;

      this.coreEngineService.save(objectData).subscribe(() => {
        this.loading = false;
        this.spinner.hide();
        this.navigateUp();
      },
      error => {
        this.loading = false;
        this.spinner.hide();
        this.dialogService.alert('Oops something went wrong...', 'We were unable to process your request at this time, please try again in a few moments. Please contact CUE support at support@connectwithcue.com if you continue to experience issues', this.viewRef);
      });
  }

  public navigateUp() {
    this.router.navigate(['portal/audio-qr']);
  }
}
